<template>
<div>
        <div class="pit columns">
        <h2>基坑自动化监测</h2>
        <div class="all">
          <p>
              岩石科技基坑安全监测预警系统（Roc Pit）以物联网为基础，结构安全监测为行业依托，利用云计算技术创立基坑健康状态的理念。 将基坑监测与物联网结构体系、云计算、互联网等技术结合，建立一套智能基坑在线监测系统。
          </p>
        </div>
        <div class="brief_box">

            <div class="title_box row">
                <div class="blue_line"></div>
                <h5>项目基本情况</h5>
            </div>
            <p>通过对基坑的支护结构、相关自然环境、施工工况、地下水状况、 基坑底部及周围土体、周围建（构）筑物、周围地下管线及地下 设施、周围重要的道路等等能够帮助现场作业人员<br/>、项目管理人 员等减少作业强度、及时了解项目健康动态，并可为生产决策提 供及时可靠的项目信息，为项目顺利实施安全护航。</p>
             
              <div class="title_box row">
                <div class="blue_line"></div>
                <h5>监测参数</h5>
            </div>
            <p>支护结构应力（钢筋计/锚索计）</p>
            <p>地下水状况（渗压计）</p>
            <p>基坑底部沉降（静力水准）</p>
            <p>周围土体受力（土压力计）</p>
            <p>深层位移（多点位移计）</p>
            <p>地表位移（测量机器人）</p>
            <p>裂缝（裂缝计）</p>
            <p>建筑物位移 / 沉降（GNSS/ 测量 机器人）</p>
            <p>结构应力应变（应力计/应变计）</p>
            <p>气象环境监测（气象站）</p>
            <p>现场状况（视频系统）</p>
            <p>地震（加速度传感器）</p>

            <div class="title_box row">
                <div class="blue_line"></div>
                <h5>推荐设备</h5>
            </div>
            <p>监测设备：</p>
            <p>Topcon MS/DS系列测量机器人</p>
            <p>RT-VW-4300振弦式多点位移计</p>
            <p>RT-VW-2300振弦式钢筋计</p>
            <p>RT-VW-1200振弦式表面应变计</p>
            <p>RT-DT-5100液压式静力水准</p>
            <p>RT-VW-3100振弦式渗压计</p>
            <p>RT-VW-4100振弦式裂缝计</p>
            <p>RT-DT-8100系列多参数气象站</p>
            <p>低频测振传感器</p>
            
            <h6>监测终端:</h6>
            <p>RocBox RT2000监测终端</p> 
            <p>RocMIoT监测物联网系列产品</p>  
            <p>振动信号采集仪</p>  
            <p>RocHand智能采集手簿
</p>              
        </div>    
    </div>
     <foot></foot>

</div>

</template>
<style>
.pit {
  width: 100%;
  background-color: rgba(245, 245, 245, 1);
}
h2 {
  font-size: 0.36rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  margin-top: 0.55rem;
  margin-bottom: 0.36rem;
}
.all {
  width: 11.4rem;
  height: 0.4rem;
  background: rgba(255, 255, 255, 1);
  border: 0.01rem solid rgba(221, 221, 221, 1);
  margin: 0 auto;
  padding: 0.3rem;
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
}
.brief_box {
  width: 12rem;
  background: rgba(255, 255, 255, 1);
  border: 0.01rem solid rgba(221, 221, 221, 1);
  margin-top: 0.2rem;
  margin-bottom: 0.67rem;
  padding-bottom: .64rem;
}
.brief_box p,
 .brief_box h6{
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
  padding-left: 0.4rem;
  padding-top: 0.1rem;
}
.brief_box h6{
    padding-top: .3rem;
}
.title_box {
  margin-left: 0.4rem;
  margin-top: 0.37rem;
  font-size: 0.16rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  line-height: 0.2rem;
}
.blue_line {
  width: 0.03rem;
  height: 0.2rem;
  background: rgba(67, 148, 208, 1);
  margin-right: 0.1rem;
}
</style>

<script>
import footer from "../../common/footer";
export default {
  data() {
    return {};
  },
  components: {
    foot: footer
  }
};
</script>





// WEBPACK FOOTER //
// src/homepages/solutionpage/pit.vue